/**
 * Shared behaviour for input components
 *
 * @mixin input
 */
export default {
  data() {
    return {
      hasFocus: false
    }
  },

  props: {
    placeholder: String,
    helperText: String,
    error: String,

    value: {
      type: [String, Number, Object],
      default: ''
    },
    
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      default: false 
    }
  },

  computed: {
    currentValue: {
      get() {
        return this.value
      },

      set(newValue) {
        this.$emit('input', newValue)
      }
    },

    hasValue() {
      return !!this.currentValue
    },

    /**
     * component classList
     *
     * @returns {object} classnames object
     */
    classList() {
      return {
        'has-focus': this.hasFocus,
        'has-value': this.hasValue,
        'is-invalid': this.error,
        'disabled': this.disabled
      }
    },

    count() {
      return this.value.length
    },

    /**
     * used to join label to input
     *
     * @returns {string} uid of component
     */
    id() {
      return this._uid
    }
  },

  methods: {
    clear() {
      this.$emit('input', null)
    },

    focus() {
      this.hasFocus = true
    },

    blur() {
      this.hasFocus = false
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/mixins/input.js
// module id = null
// module chunks = 